export const getNewUiUrl = () => {
    // In development, xg-new-ui runs on port 3055
    if (process.env.NODE_ENV === 'development') {
        return 'http://localhost:3055';
    }
    // In production, everything is handled by Nginx on the same origin
    return '';
};
